import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { get, post } from '../service/api';
import { toast } from 'react-toastify';
import { coinDetailAction } from '../redux/actions/coinDetailAction';
import {
  FaCoins,
  FaCalculator,
  FaTrash,
  FaPlay,
  FaCheckCircle,
  FaTimesCircle,
  FaHistory,
  FaGamepad,
  FaPlusCircle,
  FaClipboard,
  FaEdit,
  FaMoneyBillWave,
  FaExchangeAlt,
  FaSyncAlt,
} from 'react-icons/fa';
import { GiTwoCoins, GiPokerHand } from 'react-icons/gi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const OpenGames = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: gameId } = useParams();

  console.log('gameId', gameId);
  const game = location.state;
  console.log('game', game);
  // const gameId = game?.game_id;
  const dispatch = useDispatch();

  const userDetail = useSelector(
    (state) => state.userDetailReducer?.userDetail,
  );
  const coinDetails = useSelector(
    (state) => state.coinDetailReducer?.coinDetail,
  );

  const [inputText, setInputText] = useState('');
  const [betAmount, setBetAmount] = useState('10');
  const [betNumberArr, setBetNumberArr] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [quickAmounts] = useState([5, 10, 15, 20, 30, 50]);
  const [includeOpposite, setIncludeOpposite] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    getCoinData();
  }, []);

  const getCoinData = async () => {
    try {
      const data = await get(`wallets/getWallet/${userDetail?.user_id}`);
      if (data?.length > 0) {
        const amount = data[0].total_amount;
        const wallet_id = data[0]._id;
        dispatch(
          coinDetailAction({ amount: Number(amount).toFixed(2), wallet_id }),
        );
      }
    } catch {
      toast.error('Failed to fetch wallet data', { autoClose: 2000 });
    }
  };

  const handleInputChange = (text) => {
    setInputText(text);
    setErrorMessage('');
  };

  const handleAmountChange = (value) => {
    const num = value.replace(/[^0-9]/g, '');
    const limitedNum = num.slice(0, 6);
    setBetAmount(limitedNum === '' ? '' : limitedNum);
  };

  // Generate opposite of a pair (e.g., 12 -> 21, 45 -> 54)
  const getOppositePairs = (numbers) => {
    const oppositePairs = new Set();

    numbers.forEach((number) => {
      if (number.length === 2) {
        // Reverse the digits
        const opposite = number[1] + number[0];
        oppositePairs.add(opposite);
      }
    });

    return Array.from(oppositePairs);
  };

  const autoParseNumbers = (text, includeOpposites = false) => {
    // Extract all numbers from text (supporting various formats)
    const numbers = text.match(/\d+/g);

    if (!numbers || numbers.length === 0) {
      setErrorMessage('No numbers found in input');
      return [];
    }

    // Join all numbers and split into pairs
    const allDigits = numbers.join('');
    const pairs = new Set();

    for (let i = 0; i < allDigits.length; i += 2) {
      const pair = allDigits.slice(i, i + 2);
      if (pair.length === 2) {
        // Convert to 00-99 format
        const formattedPair = pair.padStart(2, '0');
        pairs.add(formattedPair);

        // Add opposite pair if needed
        if (includeOpposites) {
          const oppositePair = pair[1] + pair[0];
          const formattedOpposite = oppositePair.padStart(2, '0');
          pairs.add(formattedOpposite);
        }
      }
    }

    // Convert to array with IDs
    const pairsArray = Array.from(pairs).map((pair) => ({
      id: `${pair}-${Date.now()}-${Math.random()}`,
      number: pair,
      amount: Number(betAmount) || 0,
    }));

    return pairsArray;
  };

  const handleAddNumbers = () => {
    if (!inputText.trim()) {
      toast.warning('Please enter numbers or patterns', { autoClose: 2000 });
      return;
    }

    if (!betAmount || Number(betAmount) < 1) {
      toast.error('Please enter a valid bet amount', { autoClose: 2000 });
      return;
    }

    // Process the input text with opposite pairs if selected
    const parsedPairs = autoParseNumbers(inputText, includeOpposite);

    if (parsedPairs.length > 0) {
      setBetNumberArr(parsedPairs);
      toast.success(
        `Added ${parsedPairs.length} number pairs${
          includeOpposite ? ' (with palti)' : ''
        }`,
        {
          autoClose: 1500,
        },
      );
    } else {
      setErrorMessage('Could not extract valid number pairs from input');
    }
  };

  const handleToggleOpposite = () => {
    if (!inputText.trim() || betNumberArr.length === 0) {
      toast.warning('Please add numbers first', { autoClose: 2000 });
      return;
    }

    setIncludeOpposite(!includeOpposite);

    if (includeOpposite) {
      // Remove opposite pairs - keep only original numbers
      const originalNumbers = autoParseNumbers(inputText, false);
      setBetNumberArr(originalNumbers);
      toast.success('Removed opposite pairs', { autoClose: 1500 });
    } else {
      // Add opposite pairs
      const parsedPairs = autoParseNumbers(inputText, true);
      setBetNumberArr(parsedPairs);
      toast.success('Added opposite pairs', { autoClose: 1500 });
    }
  };

  const handleQuickAmount = (amount) => {
    setBetAmount(amount.toString());
  };

  const handleClearAll = () => {
    setInputText('');
    setBetNumberArr([]);
    setBetAmount('10');
    setIncludeOpposite(false);
    setErrorMessage('');
    toast.info('All data cleared', { autoClose: 1500 });
  };

  const handleRemoveNumber = (id) => {
    setBetNumberArr((prev) => prev.filter((item) => item.id !== id));
  };

  const handleDeleteAllNumbers = () => {
    setBetNumberArr([]);
    setIncludeOpposite(false);
    toast.info('All numbers removed', { autoClose: 1500 });
  };

  const getGameStatus = async () => {
    try {
      const res = await get(`/games/getGameDetails/${gameId}`);
      if (res?.status === 'active') {
        await handleContinue();
      } else {
        toast.error('Game is closed. Bet not allowed', { autoClose: 2000 });
      }
    } catch {
      toast.error('Something went wrong', { autoClose: 2000 });
    }
  };

  const handleContinue = async () => {
    if (betNumberArr.length === 0) {
      toast.error('Please add at least one number pair', { autoClose: 2000 });
      return;
    }

    if (!betAmount || Number(betAmount) < 1) {
      toast.error('Please enter a valid bet amount', { autoClose: 2000 });
      return;
    }

    const totalBetAmount = Number(betAmount) * betNumberArr.length;

    if (totalBetAmount > (coinDetails?.amount || 0)) {
      toast.error(
        `Insufficient balance. Available: ₹${coinDetails?.amount || 0}`,
        { autoClose: 2000 },
      );
      return;
    }

    const betData = betNumberArr.map((item) => ({
      bet_number: item.number,
      bet_amount: Number(betAmount),
    }));

    const formData = {
      game_id: gameId,
      bets: betData,
      user_id: userDetail?.user_id,
      total_ammount_spend: totalBetAmount,
      wallet_id: coinDetails?.wallet_id,
    };

    setIsSubmitting(true);
    try {
      await post('game_bets/createGameBets', formData);
      toast.success('Bet placed successfully!', { autoClose: 1000 });
      handleClearAll();
      await getCoinData();
    } catch {
      toast.error('Failed to place bet', { autoClose: 2000 });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePasteNumbers = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setInputText(text);
      toast.success('Pasted from clipboard', { autoClose: 1500 });
    } catch (error) {
      toast.error('Could not paste from clipboard', { autoClose: 2000 });
    }
  };

  const totalBetAmount = Number(betAmount) * betNumberArr.length;

  return (
    <div className="open-games-container">
      {/* Header */}
      <div className="game-header">
        <div className="balance-display">
          <div className="balance-icon">
            <FaCoins />
          </div>
          <div className="balance-info">
            <div className="balance-label">Available Balance</div>
            <div className="balance-amount">
              ₹{coinDetails?.amount || '0.00'}
            </div>
          </div>
          <div className="stat-details">
            <div className="stat-value">
              {game?.product_name || 'Open Games'}
            </div>
            <div className="stat-label">Game</div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="open-games-content">
        {/* Input Section */}
        <div className="input-section">
          <div className="section-header">
            <div className="input-actions">
              <button className="action-btn" onClick={handlePasteNumbers}>
                <FaClipboard />
                Paste
              </button>
            </div>
          </div>

          <div className="input-container">
            <div className="input-group">
              <div className="input-label">
                <span className="label-icon">🔢</span>
                <span>Numbers dalo</span>
              </div>
              <textarea
                className="number-input"
                value={inputText}
                onChange={(e) => handleInputChange(e.target.value)}
                placeholder="Enter numbers in any format: 12 13 14, 12-13-14, 121314, etc."
                rows={3}
              />
              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}

              {/* Opposite Button Below Input */}
              {/* <div className="opposite-button-container">
                <button
                  className={`opposite-btn ${includeOpposite ? 'active' : ''}`}
                  onClick={handleToggleOpposite}
                  disabled={!inputText.trim()}
                >
                  <FaExchangeAlt className="opposite-icon" />
                  <span>{includeOpposite ? 'NO PALTI' : 'PALTI'}</span>
                  {includeOpposite && <FaSyncAlt className="toggle-icon" />}
                </button>
              </div> */}
            </div>

            <div className="amount-group">
              <div className="input-label">
                <span className="label-icon">💰</span>
                <span>Bet Amount per Pair</span>
              </div>

              <div className="amount-input-container">
                <input
                  type="text"
                  className="amount-input"
                  value={betAmount}
                  onChange={(e) => handleAmountChange(e.target.value)}
                  placeholder="Enter amount"
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
                <div className="amount-currency">₹</div>

                <button
                  className={`opposite-btn ${includeOpposite ? 'active' : ''}`}
                  onClick={handleToggleOpposite}
                  disabled={!inputText.trim()}
                >
                  <FaExchangeAlt className="opposite-icon" />
                  <span>{includeOpposite ? 'NO PALTI' : 'PALTI'}</span>
                  {includeOpposite && <FaSyncAlt className="toggle-icon" />}
                </button>
              </div>
              <div className="amount-input-container">
                <button
                  className="action-btn submit"
                  onClick={handleAddNumbers}
                  disabled={!inputText || !betAmount}
                >
                  <FaPlusCircle className="btn-icon" />
                  <span> Add Numbers</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Amounts */}
        <div className="quick-amounts-section">
          <div className="section-header">
            <FaMoneyBillWave className="section-icon" />
            <h3>Quick Amounts</h3>
          </div>

          <div className="quick-amounts">
            {quickAmounts.map((amount) => (
              <button
                key={amount}
                className={`quick-amount-btn ${
                  betAmount === amount.toString() ? 'active' : ''
                }`}
                onClick={() => handleQuickAmount(amount)}
              >
                ₹{amount}
              </button>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button
            className="action-btn danger"
            onClick={handleDeleteAllNumbers}
            disabled={betNumberArr.length === 0}
          >
            <FaTrash className="btn-icon" />
            <span>Clear </span>
          </button>

          <button
            className="action-btn warning"
            onClick={handleClearAll}
            disabled={!inputText && betNumberArr.length === 0 && !betAmount}
          >
            <FaTimesCircle className="btn-icon" />
            <span>Reset </span>
          </button>
        </div>

        {/* Selected Numbers Display */}
        {betNumberArr.length > 0 && (
          <div className="selected-numbers-section">
            <div className="section-header">
              <FaCheckCircle
                className={`section-icon ${includeOpposite ? 'success' : ''}`}
              />
              <h3>
                Selected Number JODI ({betNumberArr.length})
                {includeOpposite && (
                  <span className="opposite-badge">with Opposite</span>
                )}
              </h3>
              {/* <div className="numbers-summary">
                <div className="summary-item">
                  <span className="summary-label"> Jodi:</span>
                  <span className="summary-value">{betNumberArr.length}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Amount</span>
                  <span className="summary-value">₹{betAmount}</span>
                </div>
              </div> */}
            </div>

            <div className="numbers-grid">
              {betNumberArr.map((item) => (
                <div
                  key={item.id}
                  className="number-card"
                  onClick={() => handleRemoveNumber(item.id)}
                >
                  <div className="number-value">{item.number}</div>
                  <div className="number-amount">₹{item.amount}</div>
                  <div className="remove-overlay">
                    <FaTimesCircle />
                    Remove
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Action Bar */}
      <div className="action-bar">
        <div className="total-display">
          <div className="total-label">
            <FaCalculator className="total-icon" />
            <span>Total Bet Amount</span>
          </div>
          <div className="total-amount">₹{totalBetAmount}</div>
        </div>

        <div className="action-buttons-bar">
          {/* <button
            className="action-btn reset"
            onClick={handleClearAll}
            disabled={betNumberArr.length === 0}
          >
            <FaTrash />
            Clear All
          </button> */}

          <button
            className={`action-btn submit ${
              totalBetAmount === 0 || isSubmitting ? 'disabled' : ''
            }`}
            onClick={getGameStatus}
            disabled={totalBetAmount === 0 || isSubmitting}
          >
            {isSubmitting ? (
              <>
                <div className="spinner"></div>
                Placing Bet...
              </>
            ) : (
              <>
                <FaPlay />
                Place Bet ({betNumberArr.length} pairs)
              </>
            )}
          </button>
        </div>
      </div>

      {/* Quick Info */}
      <div className="quick-info">
        <div className="info-item">
          <FaCheckCircle className="info-icon success" />
          <span>Enter numbers in any format - auto-pairing supported</span>
        </div>
        <div className="info-item">
          <FaExchangeAlt className="info-icon" />
          <span>"With Opposite" adds reverse pairs (e.g., 12 → 21)</span>
        </div>
      </div>

      <style jsx>{`
        .open-games-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #0c2461 0%, #1e3799 100%);
          color: white;
          touch-action: manipulation;
        }

        .game-header {
          padding: 15px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(255, 255, 255, 0.08);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .balance-display {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .balance-icon {
          width: 45px;
          height: 45px;
          background: linear-gradient(
            135deg,
            rgba(255, 193, 7, 0.2),
            rgba(255, 140, 0, 0.1)
          );
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          color: #ffd700;
          border: 1px solid rgba(255, 193, 7, 0.3);
        }

        .balance-info {
          display: flex;
          flex-direction: column;
        }

        .balance-label {
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 2px;
        }

        .balance-amount {
          font-size: 1.2rem;
          font-weight: 800;
          color: white;
        }

        .game-stats {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .stat-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .stat-icon {
          font-size: 1.2rem;
          color: #4cd964;
        }

        .stat-details {
          display: flex;
          flex-direction: column;
        }

        .stat-value {
          font-size: 0.85rem;
          font-weight: 600;
          color: white;
        }

        .stat-label {
          font-size: 0.7rem;
          color: rgba(255, 255, 255, 0.7);
        }

        .open-games-content {
          padding: 20px;
          max-width: 100%;
          margin: 0 auto;
          padding-bottom: 150px;
        }

        /* Input Section */
        .input-section {
          margin-bottom: 25px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 15px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .input-actions {
          display: flex;
          gap: 10px;
        }

        .input-actions .action-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 12px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          color: white;
          font-size: 0.85rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .input-actions .action-btn:hover {
          background: rgba(255, 255, 255, 0.15);
        }

        .input-container {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .input-group {
          flex: 1;
        }

        .input-label {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.9);
        }

        .label-icon {
          font-size: 1rem;
        }

        .number-input {
          width: 100%;
          min-height: 100px;
          padding: 15px;
          background: rgba(255, 255, 255, 0.1);
          border: 2px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          color: white;
          font-size: 1rem;
          font-weight: 500;
          outline: none;
          transition: all 0.3s ease;
          resize: vertical;
          font-family: inherit;
          margin-bottom: 15px;
        }

        .number-input:focus {
          border-color: #4cd964;
          background: rgba(76, 217, 100, 0.1);
        }

        .number-input::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

        .error-message {
          color: #ff6b6b;
          font-size: 0.85rem;
          margin-top: 8px;
          padding-left: 5px;
          margin-bottom: 10px;
        }

        /* Opposite Button */
        .opposite-button-container {
          margin-top: 10px;
        }

        .opposite-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 40%;
          padding: 12px;
          background: rgba(255, 255, 255, 0.1);
          border: 2px solid rgba(255, 255, 255, 0.2);
          border-radius: 10px;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .opposite-btn:hover:not(:disabled) {
          background: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
        }

        .opposite-btn.active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-color: rgba(102, 126, 234, 0.5);
        }

        .opposite-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .opposite-icon {
          font-size: 1rem;
        }

        .toggle-icon {
          font-size: 0.8rem;
          margin-left: auto;
        }

        .amount-group {
          flex: 1;
        }

        .amount-input-container {
          position: relative;
          display: flex;
          align-items: center;
          margin-top: 20px;
          justify-content: space-between;
        }

        .amount-input {
          width: 40%;
          height: 60px;
          padding: 15px 15px 15px 45px;
          background: rgba(255, 255, 255, 0.1);
          border: 2px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          color: white;
          font-size: 1.5rem;
          font-weight: 700;
          outline: none;
          transition: all 0.3s ease;
          text-align: center;
        }

        .amount-input:focus {
          border-color: #4cd964;
          background: rgba(76, 217, 100, 0.1);
        }

        .amount-currency {
          position: absolute;
          left: 15px;
          color: #4cd964;
          font-size: 1.5rem;
          font-weight: 700;
        }

        /* Quick Amounts Section */
        .quick-amounts-section {
          margin-bottom: 25px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 15px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .quick-amounts {
          display: grid;
          justify-content: center;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .quick-amount-btn {
          padding: 8px;
          width: 100px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 10px;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .quick-amount-btn:hover {
          background: rgba(255, 255, 255, 0.15);
        }

        .quick-amount-btn.active {
          background: linear-gradient(135deg, #4cd964, #2ecc71);
          border-color: rgba(76, 217, 100, 0.5);
        }

        /* Action Buttons */
        .action-buttons {
          display: flex;
          gap: 12px;
          margin-bottom: 25px;
          flex-wrap: wrap;
        }

        .action-buttons .action-btn {
          flex: 1;
          min-width: 120px;
          padding: 15px 10px;
          border: none;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 0.9rem;
        }

        .action-buttons .action-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .action-buttons .action-btn.primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        .action-buttons .action-btn.primary:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
        }

        .action-buttons .action-btn.danger {
          background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
        }

        .action-buttons .action-btn.danger:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 65, 108, 0.3);
        }

        .action-buttons .action-btn.warning {
          background: linear-gradient(135deg, #ffb347 0%, #ffcc33 100%);
        }

        .action-buttons .action-btn.warning:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 179, 71, 0.3);
        }

        .btn-icon {
          font-size: 1.2rem;
        }

        /* Selected Numbers Section */
        .selected-numbers-section {
          margin-bottom: 200px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 15px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .section-header h3 {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .opposite-badge {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 4px 10px;
          border-radius: 15px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .numbers-summary {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
          margin-top: 10px;
          padding: 15px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }

        .summary-item {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .summary-label {
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.7);
        }

        .summary-value {
          font-size: 1.1rem;
          font-weight: 700;
          color: #4cd964;
        }

        .numbers-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 12px;
          max-height: 500px;
          overflow-y: auto;
          padding: 15px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          margin-top: 15px;
        }

        .numbers-grid::-webkit-scrollbar {
          width: 6px;
        }

        .numbers-grid::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 3px;
        }

        .numbers-grid::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 3px;
        }

        .number-card {
          position: relative;
          padding: 15px 5px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          overflow: hidden;
        }

        .number-card:hover {
          background: rgba(255, 107, 107, 0.15);
          transform: scale(1.05);
        }

        .number-value {
          font-size: 1.3rem;
          font-weight: 800;
          color: white;
          margin-bottom: 5px;
        }

        .number-amount {
          font-size: 0.9rem;
          color: #4cd964;
          font-weight: 600;
        }

        .remove-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 107, 107, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.8rem;
          font-weight: 600;
          color: white;
          opacity: 0;
          transition: opacity 0.3s ease;
          flex-direction: column;
          gap: 5px;
        }

        .number-card:hover .remove-overlay {
          opacity: 1;
        }

        /* Action Bar */
        .action-bar {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(
            to top,
            rgba(12, 36, 97, 0.95),
            rgba(30, 55, 153, 0.9)
          );
          backdrop-filter: blur(10px);
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding: 15px 20px;
          z-index: 100;
        }

        .total-display {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          padding: 12px 15px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .total-label {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.8);
        }

        .total-icon {
          color: #4cd964;
        }

        .total-amount {
          font-size: 1.5rem;
          font-weight: 800;
          color: white;
        }

        .action-buttons-bar {
          display: flex;
          gap: 15px;
        }

        .action-btn.reset {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 15px;
          background: rgba(255, 107, 107, 0.2);
          border: 1px solid rgba(255, 107, 107, 0.3);
          border-radius: 12px;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .action-btn.reset:hover:not(:disabled) {
          background: rgba(255, 107, 107, 0.3);
          transform: translateY(-2px);
        }

        .action-btn.reset:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .action-btn.submit {
          flex: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 15px;
          background: linear-gradient(135deg, #4cd964, #2ecc71);
          border: none;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .action-btn.submit:hover:not(.disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(76, 217, 100, 0.4);
        }

        .action-btn.submit.disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Quick Info */
        .quick-info {
          margin-top: 20px;
          padding: 15px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .quick-info .info-item {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 8px;
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.7);
        }

        .quick-info .info-item:last-child {
          margin-bottom: 0;
        }

        .quick-info .info-icon {
          font-size: 0.9rem;
        }

        .quick-info .info-icon.success {
          color: #4cd964;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .open-games-content {
            padding: 15px;
          }

          .quick-amounts {
            grid-template-columns: repeat(3, 1fr);
          }

          .numbers-grid {
            grid-template-columns: repeat(4, 1fr);
          }

          .action-buttons {
            flex-direction: column;
          }

          .action-buttons .action-btn {
            min-width: 100%;
          }

          .action-bar {
            padding: 12px 15px;
          }

          .action-buttons-bar {
            flex-direction: column;
          }

          .numbers-summary {
            flex-direction: row;
            justify-content: space-between;
            gap: 10px;
          }
        }

        @media (max-width: 480px) {
          .game-header {
            flex-direction: column;
            gap: 15px;
            align-items: flex-start;
          }

          .numbers-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .number-input {
            min-height: 80px;
          }

          .amount-input {
            height: 50px;
            font-size: 1.2rem;
          }
        }

        /* Touch Optimization */
        @media (hover: none) and (pointer: coarse) {
          .action-btn,
          .quick-amount-btn,
          .opposite-btn,
          .number-card,
          .input-actions .action-btn,
          .action-buttons .action-btn {
            min-height: 44px;
            min-width: 44px;
          }

          .number-input,
          .amount-input {
            font-size: 16px;
          }

          .numbers-grid,
          .quick-amounts {
            gap: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default OpenGames;
